import React, { useEffect, useRef, useState } from "react";
import {
  Layout,
  Menu,
  Dropdown,
  Badge,
  Tooltip,
  Breadcrumb,
  Button,
  Modal,
} from "antd";
import { Images } from "../Controller";
import { Menuitems } from "./Menuitems";
import { persistor } from "../Store/Store";
import {
  AepsDetailAutoFill,
  GetDashboardData,
  GetWalletBalance,
  MemberProfile,
  UserLogout,
  getMemberServices,
} from "../ApiServices/Apifun";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { BsArrowLeft, BsArrowRight, BsBell, BsWallet } from "react-icons/bs";
import { AiOutlineWallet } from "react-icons/ai";
import NotificationDrawer from "./NotificationDrawer";
import { ThemeColor } from "../Theme/theme";
import {
  clearAllRedux,
  setMemberService,
  setProfile,
  setWalletBal,
  setselectedTab,
} from "../Store/B2bslice";
import { dispatchtoast, trimString } from "../Utils";
import Marquee from "react-fast-marquee";
import { BiMoney, BiWallet } from "react-icons/bi";
import { ExclamationCircleFilled, SearchOutlined } from "@ant-design/icons";
// import DashboardCommon from "../Views/Main/Dashboard/DashboardCommon";
import dayjs from "dayjs";
const { Header, Sider, Content } = Layout;
const AUTO_LOGOUT_TIME = 2 * 60 * 60 * 1000;
const ProjectLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [windowwidth, setwindowwidth] = useState(window.innerWidth);
  const [showDefault, setShowDefault] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [news, setNews] = useState([]);
  const profiledetail = useSelector((state) => state.B2B.profileDetail);
  const walletBalance = useSelector((state) => state.B2B.walletBal);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const selectedTab = useSelector((state) => state.B2B.selectedTab);
  const timerRef = useRef(null);

  const resetTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      handleLogout();
    }, AUTO_LOGOUT_TIME);
  };
  const [showModalForUpdate, setShowModalForUpdate] = useState(false);
  const [showModalForEkycUpdate, setShowModalForEkycUpdate] = useState(false);
  const [expired_date, setExpired_date] = useState("");
  const [pendingRoute, setPendingRoute] = useState(null);
  const [timeLeft, setTimeLeft] = useState("");
  useEffect(() => {
    if (!expired_date) return;

    const interval = setInterval(() => {
      const now = new Date().getTime();
      const expiry = new Date(expired_date).getTime();
      const distance = expiry - now;

      if (distance <= 0) {
        setTimeLeft("Expired");
        clearInterval(interval);
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      setTimeLeft(`${days}d ${hours}h ${minutes}m ${seconds}s`);
    }, 1000);

    return () => clearInterval(interval);
  }, [expired_date]);
  const handleAutoFillDetails = () => {
    AepsDetailAutoFill()
      .then((res) => {
        setShowModalForUpdate(false);
        navigate("/banking/aeps-onboard", {
          state: {
            autoFillData: res.data,
          },
        });
      })
      .catch((err) => console.log(err));
  };
  const handleDoEkycUpdateNow = () => {
    setShowModalForEkycUpdate(false);
    navigate("/banking/aeps-ekyc");
  };
  const handleClose = () => {
    setShowModalForUpdate(false);

    if (pendingRoute) {
      navigate(pendingRoute.route, {
        state: pendingRoute.state,
      });

      setPendingRoute(null);
    }
  };
  useEffect(() => {
    const events = ["mousemove", "keydown", "scroll", "click", "touchstart"];

    events.forEach((event) => window.addEventListener(event, resetTimer));

    resetTimer();

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);

      events.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, [resetTimer]);

  useEffect(() => {
    const handleResize = () => {
      setwindowwidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    // setselectedTab(getLocalStorageItem("selectedTab"));
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {}, [selectedTab]);
  useEffect(() => {
    if (windowwidth > 1000) {
      setCollapsed(false);
      setShowDefault(true);
    } else {
      setCollapsed(true);
      setShowDefault(false);
    }
  }, [windowwidth]);

  const handleLogout = () => {
    UserLogout()
      .then((res) => {
        persistor.purge(); // This clears the persisted state
        dispatch(clearAllRedux());
        localStorage.clear();
        navigate("/");
      })
      .catch((err) => console.log(err));
  };
  const items = [
    {
      key: "1",
      label: (
        <div className="w-48">
          <div className="text-sm flex justify-start items-center">
            <AiOutlineWallet size={20} className="mr-3 text-sm text-primary" />
            <p> Wallet Balance</p>
          </div>
          <p className="font-bold text-[16px] mb-4">Rs. {walletBalance}</p>
          <hr />
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <>
          <p
            onClick={() => navigate("/personal-info")}
            className="font-medium mb-4"
          >
            View Profile
          </p>
          <hr />
        </>
      ),
    },
    {
      key: "3",
      label: (
        <p onClick={handleLogout} className="font-medium">
          Sign Out
        </p>
        //        <Popconfirm
        //    title="Logout"
        //    icon={<QuestionCircleOutlined />}
        //    description="Are you sure to logout?"
        //    onConfirm={()=>{}}
        //    onCancel={()=>{}}
        //    cancelButtonProps={{style:{color:"black"}}}
        //    okButtonProps={{style:{color:"white",background:"red"}}}
        //    okText="Yes"
        //    cancelText="No"
        //  >

        //       </Popconfirm>
      ),
    },
  ];
  const getNews = () => {
    GetDashboardData()
      .then((res) => {
        setNews(res.news);
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    getNews();
    MemberProfile()
      .then((res) => {
        if (res.status) {
          dispatch(setProfile(res.data.profile));
        } else {
          dispatchtoast("Unable to fetch profile detail", true);
        }
      })
      .catch((err) => console.log(err, "errr"));
    GetWalletBalance()
      .then((res) => {
        if (res.status) {
          dispatch(setWalletBal(res.balance));
        }
      })
      .catch((err) => console.log(err));
    getMemberServices()
      .then((res) => {
        if (res.status) {
          dispatch(setMemberService(res.services));
        }
      })
      .catch((err) => console.log(err));
  }, [selectedTab]);
  return (
    <>
      <Layout hasSider className="min-h-screen sidebar">
        <Sider
          style={{
            position: "fixed",
            marginBottom: "20px",
            overflowY: "scroll",
            height: "100vh",
          }}
          trigger={null}
          collapsible
          className="my-10"
          collapsed={collapsed}
        >
          <div className="demo-logo-vertical flex justify-around items-center my-5">
            {!collapsed ? (
              <>
                <div className="flex gap-4 justify-start items-center">
                  {" "}
                  <img
                    src={Images.WebsiteLogo}
                    className="h-10 w-[85%] ml-5"
                    alt="Weblogo"
                  />
                </div>
                <img
                  onClick={() => setCollapsed(!collapsed)}
                  className="cursor-pointer"
                  src={Images.hamburger}
                  alt="logo"
                  width={30}
                  height={30}
                />
              </>
            ) : (
              <img
                src={Images.WebsiteSmallLogo}
                alt="WeblogoSmall"
                className="h-10 w-10"
              />
            )}
          </div>
          <Menu
            theme="dark"
            mode="inline"
            defaultSelectedKeys={["1"]}
            selectedKeys={[selectedTab]}
            items={Menuitems({
              showModalForUpdate,
              setShowModalForUpdate,
              setPendingRoute,
              setShowModalForEkycUpdate,
              showModalForEkycUpdate,
              setExpired_date,
              expired_date,
            })}
          />
        </Sider>
        <Layout className="w-full">
          <Header
            style={{
              marginLeft: collapsed ? 75 : 230,
              // background:"linear-gradient(169deg, rgb(245, 14, 14) 0%, rgb(255 255 255) 0%, rgb(33, 111, 242) 100%, rgb(227, 9, 9) 100%)"
            }}
            className=" bg-white mt-4 flex justify-between items-center h-20"
          >
            <div className=" flex flex-wrap justify-start gap-x-3 mx-4  items-center">
              {collapsed ? (
                <p>
                  {" "}
                  <BsArrowRight
                    size={30}
                    onClick={() => setCollapsed(!collapsed)}
                    className="text-primary cursor-pointer"
                  />
                </p>
              ) : (
                ""
              )}
            </div>
            <div className=" flex flex-wrap justify-start gap-x-4 mx-4  items-center">
              <div className="rounded-md px-4 hidden lg:block  bg-inputbg ">
                <input
                  placeholder="Search here..."
                  className="outline-none border-none px-4 text-xs bg-gray-100 "
                />
                <SearchOutlined className="text-xl" />
              </div>
              <div className="rounded-md  flex items-center">
                <BsWallet className="h-7 w-7 text-primary font-normal" />
                <div className="outline-none border-none px-2 text-xs  py-2 rounded-md">
                  <p className=" font-bold text-base text-primary">
                    ₹ {profiledetail.aeps_wallet}
                  </p>
                  <p className=" font-semibold text-primary">AEPS-3 Wallet</p>
                </div>
              </div>
              <Tooltip title="Notification" placement="top">
                <div
                  className="mt-4 cursor-pointer"
                  onClick={() => setOpenDrawer(true)}
                >
                  <Badge
                    color={ThemeColor.primary}
                    className="text-black"
                    count={5}
                  >
                    <BsBell className=" text-primary" size={20} />
                  </Badge>
                </div>
              </Tooltip>

              <Dropdown
                className="dropdownMenu cursor-pointer sm:hidden md:hidden"
                menu={{ items }}
                trigger={["click"]}
              >
                <img
                  onError={(e) => {
                    e.target.src = Images.dummyuser;
                    e.target.alt = "userImg";
                  }}
                  src={profiledetail.avatar}
                  className="bg-bswhite rounded-full  w-8 h-8"
                  width={"30px"}
                  alt="userImg"
                  height={"30px"}
                />
              </Dropdown>
              <Dropdown
                className="dropdownMenu "
                menu={{ items }}
                trigger={["click"]}
              >
                <div className="md:flex sm:flex justify-around hidden  items-center w-36 cursor-pointer hover:bg-primaryhover h-11 rounded-full bg-primary">
                  <div className="leading-5 ml-2">
                    <p className="text-white font-bold">
                      Hi,{" "}
                      <Tooltip title={profiledetail.first_name}>
                        <span className="capitalize">
                          {trimString(profiledetail.first_name, 6)}
                        </span>
                      </Tooltip>
                    </p>
                    <p className="text-white font-bold">Rs. {walletBalance}</p>
                  </div>
                  <img
                    onError={(e) => {
                      e.target.src = Images.dummyuser;
                      e.target.alt = "userImg";
                    }}
                    src={profiledetail.avatar}
                    className="bg-bswhite rounded-full  w-8 h-8"
                    width={"30px"}
                    alt="userImg"
                    height={"30px"}
                  />
                </div>
              </Dropdown>
            </div>
          </Header>
          <Content
            className={`bg-loginbg h-full p-3 md:p-5 ${
              collapsed ? "ml-[75px]" : "ml-[230px]"
            }`}
          >
            <div className="mb-5 w-full flex justify-between items-center gap-4">
              <BsArrowLeft
                size={20}
                color={ThemeColor.primary}
                onClick={() => navigate(-1)}
                className="cursor-pointer"
              />
              {news.length !== 0 && (
                <div className="bg-primary rounded-sm w-full ">
                  <Marquee pauseOnHover={true} speed={50}>
                    <p>&nbsp; &nbsp;</p>
                    {news.map((i, index) => {
                      return (
                        <p
                          key={0}
                          className="py-1  rounded-md text-white  text-[17px]"
                        >
                          &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{index + 1}
                          .{" "}
                          <span className="capitalize font-bold">
                            {i.title}
                          </span>
                          : <span className="">{i.description}</span>
                        </p>
                      );
                    })}
                  </Marquee>
                </div>
              )}
              {/* {location.pathname?.includes("yes") &&
              !location.pathname?.includes("Report") ? (
                <div className="">
                  <img
                    src={Images.yesBank}
                    className="flex justify-center m-auto items-center w-56"
                    alt="yes bank"
                  />
                </div>
              ) : (
                ""
              )} */}
            </div>

            {children}
          </Content>
        </Layout>
      </Layout>
      {openDrawer && (
        <NotificationDrawer setopen={setOpenDrawer} open={openDrawer} />
      )}
      {showModalForUpdate && (
        <Modal
          open={showModalForUpdate}
          closable={false}
          centered
          footer={
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "12px",
              }}
            >
              <Button
                className="bg-gray-100 text-black border-gray-300 hover:bg-gray-400"
                onClick={() => setShowModalForUpdate(false)}
              >
                Skip
              </Button>

              <Button
                type="primary"
                onClick={handleAutoFillDetails}
                style={{
                  background: "#262626",
                  borderColor: "#262626",
                }}
              >
                Update Now
              </Button>
            </div>
          }
        >
          <div className="flex flex-col items-center py-6">
            <ExclamationCircleFilled
              style={{
                fontSize: 60,
                color: "#faad14",
                marginBottom: 16,
              }}
            />

            <h2
              style={{
                fontSize: "24px",
                fontWeight: 700,
                color: "#cf1322",
                textAlign: "center",
              }}
            >
              Onboarding Required
            </h2>

            <p
              style={{
                fontSize: "14px",
                textAlign: "center",
                marginTop: "10px",
                lineHeight: "1.8",
              }}
            >
              Your onboarding information is pending.
              <br />
              Please complete the onboarding process to continue using AEPS
              services.
              <br />
              <span style={{ fontWeight: 600, fontSize: "14px" }}>
                Last date :
              </span>
              <strong style={{ color: "#cf1322", fontSize: "14px" }}>
                {dayjs(expired_date).format("DD MMM YYYY hh:mm A")}
              </strong>
              <br />
              <span
                style={{
                  display: "inline-block",
                  marginTop: 12,
                  padding: "8px 16px",
                  background: "#fff2e8",
                  border: "1px solid #ffbb96",
                  borderRadius: 8,
                  color: "#d4380d",
                  fontWeight: 600,
                  fontSize: 18,
                }}
              >
                ⏳ Time Remaining: {timeLeft}
              </span>
            </p>
          </div>
        </Modal>
      )}
      {showModalForEkycUpdate && (
        <Modal
          open={showModalForEkycUpdate}
          closable={false}
          centered
          footer={
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "12px",
              }}
            >
              <Button onClick={() => setShowModalForEkycUpdate(false)}>
                Skip
              </Button>

              <Button
                type="primary"
                onClick={handleDoEkycUpdateNow}
                style={{
                  background: "#262626",
                  borderColor: "#262626",
                }}
              >
                Update Now
              </Button>
            </div>
          }
        >
          <div className="flex flex-col items-center py-6">
            <ExclamationCircleFilled
              style={{
                fontSize: 60,
                color: "#faad14",
                marginBottom: 16,
              }}
            />

            <h2
              style={{
                fontSize: "24px",
                fontWeight: 700,
                color: "#cf1322",
                textAlign: "center",
              }}
            >
              E-KYC Required
            </h2>

            <p
              style={{
                fontSize: "16px",
                textAlign: "center",
                marginTop: "10px",
              }}
            >
              Your KYC information is pending.
              <br />
              Please update your details to continue using AEPS services.
              <br />
              <span style={{ fontWeight: 600, fontSize: "14px" }}>
                Last date :
              </span>
              <strong style={{ color: "#cf1322", fontSize: "14px" }}>
                {dayjs(expired_date).format("DD MMM YYYY hh:mm A")}
              </strong>
              <br />
              <span
                style={{
                  display: "inline-block",
                  marginTop: 12,
                  padding: "8px 16px",
                  background: "#fff2e8",
                  border: "1px solid #ffbb96",
                  borderRadius: 8,
                  color: "#d4380d",
                  fontWeight: 600,
                  fontSize: 18,
                }}
              >
                ⏳ Time Remaining: {timeLeft}
              </span>
            </p>
          </div>
        </Modal>
      )}
    </>
  );
};

export default ProjectLayout;
